export default __webpack_public_path__ + "static/media/conf.7368b600.png";